var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "overflow": "hidden"
    }
  }, [_c('form-body', _vm._b({
    attrs: {
      "mode": "sign"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'form-body', {
    index: _vm.index
  }, false))], 1), _c('v-divider'), _c('form-noti', _vm._b({
    model: {
      value: _vm.disabled,
      callback: function ($$v) {
        _vm.disabled = $$v;
      },
      expression: "disabled"
    }
  }, 'form-noti', {
    form: _vm.form
  }, false)), _c('div', {
    staticClass: "v-btn-group flex-wrap my-12"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "color": "grey-6"
    }
  }, [_vm._v("mdi-chevron-left")]), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 이전 단계 ")])], 1), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading,
    disabled: _vm.disabled
  }, false), [_c('span', [_vm._v(" 입력 완료 ")]), _c('v-icon', {
    staticStyle: {
      "color": "white!important"
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }